import { takeEvery, fork, put, all, call } from 'redux-saga/effects'

import fetch from './../../../fetch'
import {
  baseURL,
  commonHeaders,
} from './../../../../../Containers/Confiq/index'

import {
  CREATE_PARTNER,
  CREATE_PARTNER_SUCCESS,
  CREATE_PARTNER_ERROR,
} from './../../../actionType'

function* createPartner({ payload }) {
  try {
    const response = yield call(fetch, {
      url: `${baseURL}/parse/classes/golfbookings/${payload.id}`,
      method: 'GET',
      headers: { ...commonHeaders },
    })

    console.log('mytestingResponse', response, response?.error)
    if (response?.error === undefined) {
      yield put({ type: CREATE_PARTNER_SUCCESS, payload: response })
    } else {
      yield put({ type: CREATE_PARTNER_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: CREATE_PARTNER_ERROR, payload: error })
  }
}

export function* watchCreatePartner() {
  yield takeEvery(CREATE_PARTNER, createPartner)
}

function* createPartnerSaga() {
  yield all([fork(watchCreatePartner)])
}

export default createPartnerSaga
